import t from 'tcomb';

export default function setBackground(sponsor) {

  var do_show_background = sponsor &&
    sponsor.background &&
    (sponsor.background.color || sponsor.background.image);

  if (do_show_background) {
    for (var k in sponsor.background) {
      if (k === 'image' &&  !t.Nil.is(sponsor.background[k])) {
        document.getElementsByTagName('html')[0].style['background-' + k] = 'url(' + sponsor.background[k] + ')';
      } else {
        document.getElementsByTagName('html')[0].style['background-' + k] = sponsor.background[k];
      }

    }
  }
  else {
    document.getElementsByTagName('html')[0].style['background-color'] = null;
    document.getElementsByTagName('html')[0].style['background-image'] = null;
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/setBackground.js
 **/